export const CAMPOS_FECHAMENTO_CAIXA = [
  { key: "dinheiro", id: "fechamento-dinheiro" },
  { key: "pix", id: "fechamento-pix" },
  { key: "credito_loja", id: "fechamento-credito-loja" },
  { key: "debito", id: "fechamento-debito" },
  { key: "credito", id: "fechamento-credito" },
  { key: "beneficios", id: "fechamento-beneficios" },
];

export const criarHtmlFechamentoCaixa = () => `
  <p class="fechamento-caixa-subtitle">Informe os valores conferidos para encerrar o movimento do caixa.</p>
  <div class="fechamento-caixa-grid">
    <div class="fechamento-caixa-field">
      <label for="fechamento-dinheiro" title="Meio de pagamento: Dinheiro">Dinheiro R$(=)</label>
      <input id="fechamento-dinheiro" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
    </div>
    <div class="fechamento-caixa-field">
      <label for="fechamento-pix" title="Meio de pagamento: Pix">Pix R$(=)</label>
      <input id="fechamento-pix" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
    </div>
    <div class="fechamento-caixa-field">
      <label for="fechamento-credito-loja" title="Meios de pagamento: parcelamentos, cheque, outros, crédito loja, boleto bancário, depósito bancário, transferência bancária e cashback">Crédito loja R$(=)</label>
      <input id="fechamento-credito-loja" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
    </div>
    <div class="fechamento-caixa-field">
      <label for="fechamento-debito" title="Meio de pagamento: Débito">Débito R$(=)</label>
      <input id="fechamento-debito" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
    </div>
    <div class="fechamento-caixa-field">
      <label for="fechamento-credito" title="Meio de pagamento: Crédito">Crédito R$(=)</label>
      <input id="fechamento-credito" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
    </div>
    <div class="fechamento-caixa-field">
      <label for="fechamento-beneficios">Benefícios R$(=)</label>
      <input id="fechamento-beneficios" class="swal2-input fechamento-caixa-input" inputmode="decimal" placeholder="0,00" />
      <small class="fechamento-caixa-helper">Vale alimentação, refeição e combustível</small>
    </div>
  </div>
  <div class="fechamento-caixa-total">
    <span>Total informado</span>
    <strong id="fechamento-total-informado">R$ 0,00</strong>
  </div>
`;

export const obterValoresFechamentoCaixa = (getValorFechamentoInput) =>
  CAMPOS_FECHAMENTO_CAIXA.reduce((valores, campo) => {
    valores[campo.key] = getValorFechamentoInput(campo.id);
    return valores;
  }, {});

export const valoresFechamentoCaixaValidos = (valores) =>
  Object.values(valores).every(
    (valor) => Number.isFinite(valor) && valor >= 0
  );

export const configurarTotalInformadoFechamentoCaixa = (
  getValorFechamentoInput,
  documentRef = document
) => {
  const totalElement = documentRef.getElementById(
    "fechamento-total-informado"
  );
  const atualizarTotalInformado = () => {
    const total = CAMPOS_FECHAMENTO_CAIXA.reduce((soma, campo) => {
      const valor = getValorFechamentoInput(campo.id);
      return soma + (Number.isFinite(valor) && valor >= 0 ? valor : 0);
    }, 0);

    if (totalElement) {
      totalElement.textContent = total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
  };

  CAMPOS_FECHAMENTO_CAIXA.forEach((campo) => {
    const input = documentRef.getElementById(campo.id);
    if (input) input.addEventListener("input", atualizarTotalInformado);
  });
  atualizarTotalInformado();

  const inputDinheiro = documentRef.getElementById("fechamento-dinheiro");
  if (inputDinheiro) inputDinheiro.focus();
};
